export default "__VITE_ASSET__BOK3O$Gd__"